import React from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import { Dialog, DialogContent, DialogActions } from '@material-ui/core';

import styles from './styles';
import { translate } from '../../i18n/I18nProvider';
import ActivationResultSummary from './ActivationResultSummary';
import DraggableDialog from '../DraggableDialog';
import PrimaryButton from '../customButtons/PrimaryButton';
import CustomDialogTitle from '../customDialogTitle/CustomDialogTitle';
import withSettings from '../../utils/withSettings';
import { isDefined } from '../../utils/isDefined';

const ActivationResultDialog = ({
  classes,
  settings,
  open,
  onClose,
  results,
  errors
}) => {
  return (
    <Dialog
      maxWidth="sm"
      PaperComponent={DraggableDialog}
      open={open}
      onClose={onClose}
    >
      <CustomDialogTitle onCloseClick={onClose}>
        {translate('TOOLTIP.ACTIVATION_MESSAGE_SUMMARY')}
      </CustomDialogTitle>
      <DialogContent className={classes.dialogContent}>
        {isDefined(results) ? (
          <ActivationResultSummary results={results} />
        ) : (
          isDefined(errors) && (
            <div
              className={classes.errors}
              style={{ color: settings.colors.danger }}
            >
              {errors.map((error, i) => (
                <div key={i}>{error}</div>
              ))}
            </div>
          )
        )}
      </DialogContent>
      <DialogActions className={classes.footer}>
        <PrimaryButton onClick={onClose}>
          {translate('BUTTON.CLOSE')}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default flowRight(
  withSettings,
  withStyles(styles)
)(ActivationResultDialog);
